import { autoinject } from "aurelia-dependency-injection";
import { LookupControl } from "../../../../../../../components/lookups/lookup-control/lookup-control";
import { BaseEnvironmentalVerificationTab } from "../base-environmental-verification-tab";
import { RightShipDialogServiceConstants } from "../../../../../../../../constants/basics/rightship-dialog.constants";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { ClassificationSocietyClientModel, EnergySavingEquipmentCategoryEnum, GhgVerificationRequestModel, HullPreparationStandardClientModel, PaintManufacturerClientModel, ZhipHighPerformancePaint } from "../../../../../../../../models/ghgs/ghg.models";
import { computedFrom } from "aurelia-binding";
import { Reflection } from "../../../../../../../../utilities/reflection";
import { bindable, useView } from "aurelia-framework";
import { GhgService } from "../../../../../../../../services/ghg/ghg.service";
import Enumerable from "linq";

@autoinject
@useView('views/pages/modules/ghg/pages/request-an-environmental-verification/tabs/environmental-verification-energy-saving-equipment/environmental-verification-energy-saving-equipment.html')
export class EnvironmentalVerificationEnergySavingEquipment extends BaseEnvironmentalVerificationTab {
    private readonly energyPowerLimitationName: string = "engine power limitation";

    public energySavingEquipmentLookups: LookupControl[] = [];
    public energySavingEquipmentFiles: File[] = [];
    public navigateToEEXIFunc: () => void;
    public selectedPaintManufacturers: ZhipHighPerformancePaint[] = [];
    public hullPreparationStandards: HullPreparationStandardClientModel[] = [];
    public paintManufacturers: PaintManufacturerClientModel[] = [];
    public classificationSocieties: ClassificationSocietyClientModel[] = [];
    public productNameComboBox = [];
    public productName: string[] = [];

    @bindable
    public isPaintManufacturerChanged: any = {};

    @bindable
    public isProductNameChanged: any = {};

    @computedFrom(Reflection.getPropertyPath<EnvironmentalVerificationEnergySavingEquipment>(z => z.energySavingEquipmentLookups),
    Reflection.getPropertyPath<EnvironmentalVerificationEnergySavingEquipment>(z => z.energySavingEquipmentLookups.length))
    public get hasAnyNotEnergyLimitationSavings(): boolean {
        return this.energySavingEquipmentLookups.some(lookup => lookup && lookup.selectedItem && lookup.selectedItem.name.toLowerCase() != this.energyPowerLimitationName);
    }
 
    @computedFrom(Reflection.getPropertyPath<EnvironmentalVerificationEnergySavingEquipment>(z => z.energySavingEquipmentLookups),
    Reflection.getPropertyPath<EnvironmentalVerificationEnergySavingEquipment>(z => z.energySavingEquipmentLookups.length))
    public get hasAnyEnergyLimitationSavings(): boolean {
        return this.energySavingEquipmentLookups.some(lookup => lookup && lookup.selectedItem && lookup.selectedItem.name.toLowerCase() == this.energyPowerLimitationName);
    }

    attached() {
        this.ghgService.getHullPreparationStandards().then(response => {
            this.hullPreparationStandards = response.hullPreparationStandards;
        });

        this.ghgService.getPaintManufacturers().then(response => {
            this.paintManufacturers = response.paintManufacturers;
        });

        this.ghgService.getClassificationSocieties().then(response => {
            this.classificationSocieties = response.classificationSocieties;
        });
    }

    shouldDisableCatAndEquipment() {
        
        //Disable category and equipment lookups if hasOriginalSpeedPowerCurveUpdated is yes and paint type is selected in Vessel Details
        if(this.ghgVerification.hasOriginalSpeedPowerCurveUpdated && this.ghgVerification.paintTypeId &&
            this.ghgVerification.ghgVerificationEnergySavingEquipments[this.ghgVerification.ghgVerificationEnergySavingEquipments.length - 1].submittedEnergySavingEquipmentCategoryId == EnergySavingEquipmentCategoryEnum.Operations &&
            this.ghgVerification.ghgVerificationEnergySavingEquipments[this.ghgVerification.ghgVerificationEnergySavingEquipments.length - 1].submittedEnergySavingEquipmentId == this.ghgVerification.paintTypeId) {
            return true;
        }
    }

    activate(model: GhgVerificationRequestModel): void {
        super.activate(model);
        this.energySavingEquipmentFiles = model.energySavingEquipmentFiles;

        //If energy saving equipment list is empty, add an empty entry by default
        if (this.ghgVerification.ghgVerificationEnergySavingEquipments.length == 0) {
            this.addEnergySavingEquipment();
        }

        // These values were carried forward from Vessel Details / EEDI / EVDI
        if (this.ghgVerification.hasOriginalSpeedPowerCurveUpdated && this.ghgVerification.paintTypeId) {
            this.ghgVerification.ghgVerificationEnergySavingEquipments[this.ghgVerification.ghgVerificationEnergySavingEquipments.length - 1].submittedEnergySavingEquipmentCategoryId = EnergySavingEquipmentCategoryEnum.Operations;
            this.ghgVerification.ghgVerificationEnergySavingEquipments[this.ghgVerification.ghgVerificationEnergySavingEquipments.length - 1].submittedEnergySavingEquipmentId = this.ghgVerification.paintTypeId;
            this.ghgService.getPaintTypes().then(response => {
                this.ghgVerification.ghgVerificationEnergySavingEquipments[this.ghgVerification.ghgVerificationEnergySavingEquipments.length - 1].submittedEnergySavingEquipmentName = response.paintTypes.find(paintType => paintType.id == this.ghgVerification.paintTypeId).value;
            });
        } else { // if not reset them
            this.ghgVerification.ghgVerificationEnergySavingEquipments[this.ghgVerification.ghgVerificationEnergySavingEquipments.length - 1].submittedEnergySavingEquipmentCategoryId = 0;
            this.ghgVerification.ghgVerificationEnergySavingEquipments[this.ghgVerification.ghgVerificationEnergySavingEquipments.length - 1].submittedEnergySavingEquipmentId = 0;
            this.ghgVerification.ghgVerificationEnergySavingEquipments[this.ghgVerification.ghgVerificationEnergySavingEquipments.length - 1].submittedEnergySavingEquipmentName = null;
            this.ghgVerification.ghgVerificationEnergySavingEquipments[this.ghgVerification.ghgVerificationEnergySavingEquipments.length - 1].submittedPaintManufacturerId = null;
            this.ghgVerification.ghgVerificationEnergySavingEquipments[this.ghgVerification.ghgVerificationEnergySavingEquipments.length - 1].submittedPaintManufacturerName = null;
            this.ghgVerification.ghgVerificationEnergySavingEquipments[this.ghgVerification.ghgVerificationEnergySavingEquipments.length - 1].submittedClassificationSocietyId = null;
            this.ghgVerification.ghgVerificationEnergySavingEquipments[this.ghgVerification.ghgVerificationEnergySavingEquipments.length - 1].submittedHullPreparationStandardId = null;
            this.ghgVerification.ghgVerificationEnergySavingEquipments[this.ghgVerification.ghgVerificationEnergySavingEquipments.length - 1].submittedAverageHullRoughness = null;
        }
    }

    public constructor(private dialogService: DialogClientService, private ghgService: GhgService) {
        super();
    }

    addEnergySavingEquipment() {
        this.ghgVerification.ghgVerificationEnergySavingEquipments.push({
            ghgRatingFactorSourceComment: null,
            ghgRatingFactorSourceId: null,
            ghgVerificationEnergySavingEquipmentId: 0,
            ghgVerificationId: this.ghgVerification.ghgVerificationId || 0,
            revisedEnergySavingEquipmentCategoryId: null,
            revisedEnergySavingEquipmentId: null,
            submittedEnergySavingEquipmentCategoryId: 0,
            submittedEnergySavingEquipmentId: 0,
            submittedEnergySavingEquipmentName: null,
            passed: null,
            revisedImplementedDate: null,
            submittedImplementedDate: null,
            isSelected: false,
            revisedAuxiliaryAvailabilityFactor: null,
            revisedMainAvailabilityFactor: null,
            revisedReductionToAuxiliaryEnginePower: null,
            revisedReductionToMainEnginePower: null,
            submittedAuxiliaryAvailabilityFactor: null,
            submittedMainAvailabilityFactor: null,
            submittedReductionToAuxiliaryEnginePower: null,
            submittedReductionToMainEnginePower: null,
            revisedCO2Reduction: null,
            revisedDescription: null,
            revisedEnergySavingAlternativeFuelId: null,
            revisedMaker: null,
            revisedModel: null,
            revisedNumberOfUnits: null,
            revisedStorageCapacity: null,
            submittedCO2Reduction: null,
            submittedDescription: null,
            submittedEnergySavingAlternativeFuelId: null,
            submittedMaker: null,
            submittedModel: null,
            submittedNumberOfUnits: null,
            submittedStorageCapacity: null,
            showClassificationSociety: false,
            submittedClassificationSocietyId: null,
            revisedClassificationSocietyId: null,
            submittedPaintManufacturerId: null,
            revisedPaintManufacturerId: null,
            submittedPaintManufacturerName: null,
            revisedPaintManufacturerName: null,
            submittedProductName: null,
            revisedProductName: null,
            submittedPaintTypeId: null,
            revisedPaintTypeId: null,
            submittedIsZhip: null,
            revisedIsZhip: null,
            submittedApprovedZhipProduct: null,
            revisedApprovedZhipProduct: null,
            submittedHullPreparationStandardId: null,
            submittedAverageHullRoughness: null,
            submittedEnergySavingEquipment: null,
        })
    }

    deleteEnergySavingEquipment(index: number) {
        if (index > -1) {
            this.ghgVerification.ghgVerificationEnergySavingEquipments.splice(index, 1);
            setTimeout(() => {
                this.onEquipmentSavingChanged(null);
            });
        }
    }

    onEquipmentSavingChanged(index: number) {
        const ghgVerification = index != null ? this.energySavingEquipmentLookups[index].selectedItem : null;
        if (ghgVerification) {
            if (ghgVerification.additionalData.showReductionToMainEnginePower && !ghgVerification.additionalData.showMainAvailabilityFactor) {
                this.ghgVerification.ghgVerificationEnergySavingEquipments[index].submittedMainAvailabilityFactor = 1;
            }
            if (ghgVerification.additionalData.showReductionToAuxiliaryEnginePower && !ghgVerification.additionalData.showAuxiliaryAvailabilityFactor) {
                this.ghgVerification.ghgVerificationEnergySavingEquipments[index].submittedAuxiliaryAvailabilityFactor = 1;
            }
            if (!ghgVerification.additionalData.showReductionToMainEnginePower) {
                this.ghgVerification.ghgVerificationEnergySavingEquipments[index].submittedReductionToMainEnginePower = null;
                this.ghgVerification.ghgVerificationEnergySavingEquipments[index].submittedMainAvailabilityFactor = null;
            }
            if (!ghgVerification.additionalData.showReductionToAuxiliaryEnginePower) {
                this.ghgVerification.ghgVerificationEnergySavingEquipments[index].submittedReductionToAuxiliaryEnginePower = null;
                this.ghgVerification.ghgVerificationEnergySavingEquipments[index].submittedAuxiliaryAvailabilityFactor = null;
            }
            if (!ghgVerification.additionalData.showMaker) {
                this.ghgVerification.ghgVerificationEnergySavingEquipments[index].submittedMaker = null;
            }
            if (!ghgVerification.additionalData.showModel) {
                this.ghgVerification.ghgVerificationEnergySavingEquipments[index].submittedModel = null;
            }
            if (!ghgVerification.additionalData.showStorageCapacity) {
                this.ghgVerification.ghgVerificationEnergySavingEquipments[index].submittedStorageCapacity = null;
            }
            if (!ghgVerification.additionalData.showDescription) {
                this.ghgVerification.ghgVerificationEnergySavingEquipments[index].submittedDescription = null;
            }
            if (!ghgVerification.additionalData.showCO2Reduction) {
                this.ghgVerification.ghgVerificationEnergySavingEquipments[index].submittedCO2Reduction = null;
            }
            if (!ghgVerification.additionalData.showNumberOfUnits) {
                this.ghgVerification.ghgVerificationEnergySavingEquipments[index].submittedNumberOfUnits = null;
            }
            if (!ghgVerification.additionalData.showEnergySavingAlternativeFuel) {
                this.ghgVerification.ghgVerificationEnergySavingEquipments[index].submittedEnergySavingAlternativeFuelId = null;
            }
        }

        //If current selected item is 'Engine power limitation', set 'isEplSelected' to true which has logic in the html
        if (this.energySavingEquipmentLookups[index] &&
            this.energySavingEquipmentLookups[index].selectedItem &&
            this.energySavingEquipmentLookups[index].selectedItem.name.toLowerCase() == this.energyPowerLimitationName) {
            this.ghgVerification.ghgVerificationEnergySavingEquipments[index].isEplSelected = true;
        }
        // Set EPL selected to false, unless energy saving field has been deleted
        else if (this.energySavingEquipmentLookups[index]){
            this.ghgVerification.ghgVerificationEnergySavingEquipments[index].isEplSelected = false;
        }

        if (this.energySavingEquipmentLookups[index] &&
            this.energySavingEquipmentLookups[index].selectedItem && 
            this.energySavingEquipmentLookups[index].selectedItem.name) {
            this.ghgVerification.ghgVerificationEnergySavingEquipments[index].submittedEnergySavingEquipmentName = this.energySavingEquipmentLookups[index].selectedItem.name;
        }

    }

    openEexiTab() {
        this.model.navigateToEexi();
    }
    
    openEquationGraphicDialog() {
        this.dialogService.show(RightShipDialogServiceConstants.URLs.EquationGraphicDialog, false, true, false, false);
    }

    onPaintManufacturerChanged($event, $index: number) {
        this.isPaintManufacturerChanged[$index] = true;
        this.isProductNameChanged[$index] = false;
        this.productName[$index] = null;
        this.ghgVerification.ghgVerificationEnergySavingEquipments[$index].submittedProductName = null;
        this.ghgVerification.ghgVerificationEnergySavingEquipments[$index].submittedPaintManufacturerName = $event.detail.item.name === 'Others' ? null : $event.detail.item.name;
        this.ghgVerification.ghgVerificationEnergySavingEquipments[$index].submittedIsZhip = $event.detail.item.name !== 'Others';
        this.productNameComboBox[$index] = Enumerable.from($event.detail.item.productNames)
            .where(productName => productName != null)
            .select(productName => ({id: productName, name: productName})).toArray();
    }

    onProductNameChanged($event, $index: number) {
        this.isProductNameChanged[$index] = true;
        this.ghgVerification.ghgVerificationEnergySavingEquipments[$index].submittedApprovedZhipProduct = $event.detail.item?.name !== 'Others';
        this.ghgVerification.ghgVerificationEnergySavingEquipments[$index].submittedProductName = $event.detail.item?.name === 'Others' ? null : this.productName[$index];
    }

    onIacsMemberClassChanged($event, $index: number) {
        this.ghgVerification.ghgVerificationEnergySavingEquipments[$index].showClassificationSociety = $event;
    }

    hasPaintTypes(categoryId: number, name: string) {
        return categoryId == EnergySavingEquipmentCategoryEnum.Operations && name?.toLowerCase().endsWith('hull coating');
    }
}
